export const ADD_APPOINTMENTS_DIALOG = 'ADD_APPOINTMENTS_DIALOG';
export const APPOINTMENT_ITEM_CHANGE = 'APPOINTMENT_ITEM_CHANGE';
export const IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS';
export const IMAGE_DELETED = 'IMAGE_DELETED';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const APPOINTMENT_RESET_DATA = 'APPOINTMENT_RESET_DATA';
